import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
  TableCell,
  Tooltip,
} from "@mui/material";
import {
  Preview as PreviewIcon,
  Email as EmailIcon,
  SendTimeExtension as SendTimeExtensionIcon,
  Description as DescriptionIcon,
  Download as Download,
  Delete as DeleteIcon,
  CheckCircle as CheckCircleIcon,
  MoreVert as MoreVertIcon,
  ContentCopy as ContentCopyIcon,
  Leaderboard as LeaderboardIcon,
  Autorenew as RenewIcon,
  Cancel as CancelIcon 
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const SrfActionButtons = ({
  row,
  isCSRF,
  editAccess,
  showComponent,
  handleOpen,
  SetSelectedColumn,
  submitSiteDelete,
  srfApproved,
  srfWithdraw,
  handlePrintModalOpen,
  handleOpenTimeline,
  handleOpenAuditModal,
  settings,
  handleSrfCopy,
  updateSrfDetails,
  openErrorModal,
   ...restProps
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedEntryDate, setSelectedEntryDate] = useState(null);
  const [calibrationDate, setCalibrationDate] = useState(null);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const userType = localStorage.getItem("type");

  const open1 = Boolean(anchorEl);

  return (
    <TableCell>
      <ButtonGroup size="small" aria-label="small button group">
        <Tooltip title="Edit SRF" placement="top-start">
          <Button
            id="srflist-editsrf"
            component={Link}
            to={`/inward/editInward/${row.id}`}
          >
            <PreviewIcon />
          </Button>
        </Tooltip>

          <Tooltip title="Renew Inward" placement="top-start">
          <Button
            id="srflist-editsrf"
            onClick={(e) => {
                if (window.confirm("Really want to Renew Inward?")) {
                  setOpen(true);
                }
              }}
          >
            <RenewIcon />
          </Button>
        </Tooltip>

        <Tooltip title="Download  Srf" placement="top-start">
          {/* {isCSRF ? (
            <Button onClick={() => handlePrintModalOpen(row.id)}>
              <Download />
            </Button>
          ) : ( */}
            <Button
              id="srflist-printsrf"
              component={Link}
              to={`/srf/printCsrf/${row.id}`}
            >
              <Download />
            </Button>
          {/* )} */}
        </Tooltip>

        {showComponent("delete") && (
          <Tooltip title="Delete Srf" placement="top-start">
            <Button
              id="srflist-deletesrf"
              disabled={!(userType == 1)}
              onClick={(e) => {
                if (window.confirm("Really want to delete srfs?")) {
                  submitSiteDelete(row.id);
                }
              }}
            >
              <DeleteIcon
                style={{
                  color: !(userType == 1) ? "lightgray" : "red",
                }}
              />
            </Button>
          </Tooltip>
        )}

        <Tooltip title="More Options" placement="top-start">
          <Button
            aria-controls={open1 ? "actions-menu" : undefined}
            aria-haspopup="true"
            onClick={handleMenuOpen}
          >
            <MoreVertIcon />
          </Button>
        </Tooltip>
      </ButtonGroup>

 <Dialog
      open={open}
      onClose={() => {
        setSelectedEntryDate(null);
        setCalibrationDate(null);
        setOpen(false);
      }}
    >
      <DialogTitle>Select Dates</DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <div style={{ display: "flex", gap: "16px" }}>
            <DatePicker
              label="Entry Date"
              value={selectedEntryDate}
              maxDate={new Date()}
              onChange={(newValue) => setSelectedEntryDate(newValue)}
              slotProps={{ textField: { sx: { width: 200, mt: 2 } } }}
            />
            {/* <DatePicker
              label="Calibration Date"
              value={calibrationDate}
              maxDate={new Date()}
              onChange={(newValue) => setCalibrationDate(newValue)}
              slotProps={{ textField: { sx: { width: 200, mt: 2 } } }}
            /> */}
          </div>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setSelectedEntryDate(null);
            setCalibrationDate(null);
            setOpen(false);
          }}
          color="secondary"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            if (selectedEntryDate ) {
              const confirmed = window.confirm(
                "New Inward Will Be Created\nAre you sure you want to continue?"
              );
              if (confirmed) {
                handleSrfCopy(row.id,settings,updateSrfDetails,restProps,openErrorModal, selectedEntryDate, calibrationDate);
                setSelectedEntryDate(null);
                setCalibrationDate(null);
                setOpen(false);
              }
            }
          }}
          color="primary"
          disabled={!selectedEntryDate }
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>

      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        open={open1}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          onClick={() =>
            handleOpenTimeline(row.id, row.customerName, row.serviceReqNumber)
          }
        >
          <Tooltip title="Progress List" placement="top-start">
            <Button style={{ padding: "2px 0px" }}>
              <LeaderboardIcon /> &nbsp;&nbsp; Progress
            </Button>
          </Tooltip>
        </MenuItem>

        <MenuItem
          onClick={() => {
            SetSelectedColumn(row);
            handleOpen();
          }}
        >
          <Tooltip title="Send Email" placement="top-start">
            <Button id="srflist-srfmail" style={{ padding: "2px 0px" }}>
              <EmailIcon /> &nbsp; &nbsp; Mail
            </Button>
          </Tooltip>
        </MenuItem>

        <MenuItem>
          <Tooltip title="Dispatch" placement="top-start">
            <Button
              id="srflist-srfdispatch"
              component={Link}
              to={`/srf/dispatch/${row.id}/${row.clientId}`}
              style={{ padding: "2px 0px" }}
            >
              <SendTimeExtensionIcon /> &nbsp; &nbsp; Dispatch
            </Button>
          </Tooltip>
        </MenuItem>

        <MenuItem>
          <Tooltip title="Dispatch Status" placement="top-start">
            <Button
              id="srflist-srfdispatchstatus"
              component={Link}
              to={`/srf/DispatchStatus/${row.id}`}
              style={{ padding: "2px 0px" }}
            >
              <DescriptionIcon /> &nbsp; &nbsp; Dispatch Status
            </Button>
          </Tooltip>
        </MenuItem>

        <MenuItem>
          <Tooltip
            title="Approved Srf"
            placement="top-start"
            onClick={(e) => row.approvedby ? srfWithdraw(row.id) : srfApproved(row.id)}
            style={{ padding: "2px 0px" }}
          >
            <Button>
              {row.approvedby ? <CancelIcon /> : <CheckCircleIcon />}
              &nbsp; &nbsp; {row.approvedby ? "SRF Withdraw" : "SRF Approved"}
            </Button>
          </Tooltip>
        </MenuItem>

        {settings?.["AuditSRF"] && settings?.["AuditSRF"]?.value == "true" && (
        <MenuItem
          onClick={() => {
            handleMenuClose();
            handleOpenAuditModal(row); 
          }}
        >
          <Button
            id="srflist-srfaudit"
            style={{ padding: "2px 0px" }}
          >
            <DescriptionIcon /> &nbsp; &nbsp; Audit
          </Button>
        </MenuItem>
        )}
      </Menu>
    </TableCell>
  );
};

export default SrfActionButtons;
